import { hubStore } from "$src/application/realtime/hubStore";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { DraftIdentifier } from "$src/domain/projects/drafts/DraftIdentifier";
import type { IProjectDraftRepository } from "$src/domain/projects/drafts/IProjectDraftRepository";
import { get } from "svelte/store";
import { inject, injectable } from "tsyringe";

@injectable()
export class DeleteDraft {
    
    constructor(@inject(ServiceTokens.ProjectDraftRepository) private projectDraftRepository: IProjectDraftRepository) {}

    async execute(groupStoreId: number, projectId: number): Promise<DraftIdentifier> {

        var identifier = await this.projectDraftRepository.DeleteDraft(groupStoreId, projectId);

        get(hubStore)?.stopEditingProject(groupStoreId, projectId);

        return identifier;
    }
}

export const DeleteDraftToken = Symbol('DeleteDraftToken');